import React from 'react';

import EmailForm from './components/EmailForm';


function App() {
  

  return (
    <div className="App">
      <EmailForm />
    </div>
  );
}

export default App;
